import type { RouteConfig } from "../types";
import { adminSettingsRoutes } from "./settings.routes";
import { subscriptionRoutes } from "./subscriptions.routes";
import { deploymentRoutes } from "./deployments.routes";

export const adminRoutes: RouteConfig[] = [
  ...adminSettingsRoutes,
  ...subscriptionRoutes,
  ...deploymentRoutes,
];
